function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2352 13.3087H15.4452L15.1652 13.0387C16.3652 11.6387 16.9852 9.72873 16.6452 7.69873C16.1752 4.91873 13.8552 2.69873 11.0552 2.35873C6.82524 1.83873 3.26524 5.39873 3.78524 9.62873C4.12524 12.4287 6.34524 14.7487 9.12524 15.2187C11.1552 15.5587 13.0652 14.9387 14.4652 13.7387L14.7352 14.0187V14.8087L18.9852 19.0587C19.3952 19.4687 20.0652 19.4687 20.4752 19.0587C20.8852 18.6487 20.8852 17.9787 20.4752 17.5687L16.2352 13.3087ZM10.2352 13.3087C7.74524 13.3087 5.73524 11.2987 5.73524 8.80873C5.73524 6.31873 7.74524 4.30873 10.2352 4.30873C12.7252 4.30873 14.7352 6.31873 14.7352 8.80873C14.7352 11.2987 12.7252 13.3087 10.2352 13.3087Z",
  fill: "current"
});

function SvgSearchInputIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInputIcon);
export default __webpack_public_path__ + "static/media/search-input-icon.73066bf2.svg";
export { ForwardRef as ReactComponent };